import { Navigate, useLocation } from 'react-router-dom';
import { useAuthBiogems } from './hooks/useAuthBiogems';
import PropTypes from 'prop-types';

export const ProtectedRoute = ({ children }) => {
  const {
    user,
    loading,
    currentReservations,
  } = useAuthBiogems();

  const location = useLocation();

  const isAuthenticated = !!user;

  const isAdmin = user?.administrator === true;
  const isSuperUser = user?.superuser === true;

  console.log('ProtectedRoute:', {
    path: location.pathname,
    user,
    loading,
    currentReservations,
    isAuthenticated,
    isAdmin,
    isSuperUser,
  });

  // Authentication is still loading
  if (loading) {
    return <div>Loading...</div>;
  }

  // User is not authenticated
  if (!isAuthenticated) {
    console.log('ProtectedRoute: not authenticated');

    return (
      <Navigate
        to="/login"
        state={{ from: location }}
        replace
      />
    );
  }

  // Admins and superusers do NOT need a reservation
  if (isAdmin || isSuperUser) {
    console.log(
      'ProtectedRoute: admin/superuser - access granted'
    );

    return children;
  }

  // Normal users must have a reservation
  if (
    !currentReservations ||
    currentReservations.length === 0
  ) {
    console.log(
      'ProtectedRoute: no reservation - redirecting'
    );

    return (
      <Navigate
        to="/test/reservations"
        state={{ from: location }}
        replace
      />
    );
  }

  console.log(
    'ProtectedRoute: authenticated user with reservation'
  );

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};